import React from "react";
import { useTheme } from "../../context/ThemeContext";

import {useAuth} from "../../context/AuthContext";

const Header = () => {
    const theme = useTheme();
    const { logout } = useAuth();
    
    return (
        <header
            className="d-flex justify-content-end align-items-center px-3"
            style={{
                backgroundColor: theme.colors.headerBg,
                color: theme.colors.textLight,
                paddingTop: 10,
                paddingBottom: 10,
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
        >
            <div className="d-flex align-items-center gap-3">
        <span className="fw-semibold">{/* fw-semibold is font-weight: 600 */}
            HasibX
        </span>
                <button
                    type="button"
                    className="btn btn-outline-light"
                    style={{ cursor: "pointer" }}
                    onClick={() => logout()}
                >
                    Logout
                </button>
            </div>
        </header>
    );
};

export default Header;
